import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { ModalLayout } from "@appbase/templates";
import * as dateUtil from "@appbase/util/date-helper";

@Component({
    components: { ModalLayout },
})
export default class SurveyStatisticsDetailModalView extends Vue {
    @Prop({ type: Boolean }) show!: boolean;
    @Prop({ type: Number }) questionType!: number;
    @Prop({ type: Object }) value!: {
        question: survey.SurveyStatisticsItem;
        answers: survey.PersonSurvyAnswers[];
    } | null;

    answers: survey.PersonSurvyAnswers[] = [];
    keyword: string = "";

    @Watch("value")
    onChangedValue(
        newVal: {
            question: survey.SurveyStatisticsItem;
            answers: survey.PersonSurvyAnswers[];
        } | null
    ) {
        this.init(newVal);
    }

    created() {
        if (this.value != null) {
            this.onChangedValue(this.value);
        }
    }

    convertDate(date: Date | null) {
        if (date == null) {
            return "";
        } else {
            return dateUtil.uGetDateFormat_UTC("yyyy.MM.dd H:i:s", new Date(date));
        }
    }

    onChangeKeyword() {
        let parseKeyword = this.keyword.trim().toLowerCase();

        if (parseKeyword.length > 0) {
            if (this.value?.question.questionType == 2 || this.value?.question.questionType == 3) {
                this.answers =
                    this.value?.answers.filter((a) => {
                        let nameMatch = a.displayName.toLocaleLowerCase().includes(parseKeyword);
                        let answersMatch = a.answers.findIndex((a) => a.surveyAnswer.toLocaleLowerCase().includes(parseKeyword)) >= 0;
                        return nameMatch || answersMatch;
                    }) ?? [];
            } else {
                this.answers =
                    this.value?.answers.filter((a) => {
                        let nameMatch = a.displayName.toLocaleLowerCase().includes(parseKeyword);
                        let answersMatch =
                            a.answers.findIndex((a) => {
                                if (a.exampleText === "기타") {
                                    return a.surveyAnswer.toLocaleLowerCase().includes(parseKeyword);
                                }
                                return a.exampleText.toLocaleLowerCase().includes(parseKeyword);
                            }) >= 0;
                        return nameMatch || answersMatch;
                    }) ?? [];
            }
        } else {
            this.answers = this.value?.answers ?? [];
        }
    }

    init(
        newVal: {
            question: survey.SurveyStatisticsItem;
            answers: survey.PersonSurvyAnswers[];
        } | null
    ) {
        if (newVal != null) {
            this.answers = newVal.answers;
        }

        this.keyword = "";
    }

    close() {
        this.$emit("close");
    }
}
